import { render } from "./GoogleRecaptcha.vue?vue&type=template&id=5081fe25"
import script from "./GoogleRecaptcha.vue?vue&type=script&lang=js"
export * from "./GoogleRecaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__